// src/utils/analytics.js - GA4 (gtag) initialization and helpers

export const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export function initGtag() {
  if (!GA_ID) return; // Only initialize if configured
  if (typeof window === 'undefined') return;
  if (window.gtagInitialized) return;

  // Inject the gtag.js script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  // Define dataLayer and gtag function
  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  window.gtag = gtag;

  gtag('js', new Date());
  // Disable automatic page_view; we handle SPA navigation manually
  gtag('config', GA_ID, { send_page_view: false });

  window.gtagInitialized = true;
}

export function trackPageview(path) {
  if (!GA_ID) return;
  if (typeof window === 'undefined' || !window.gtag) return;
  const page_path = path || window.location.pathname + window.location.search;
  window.gtag('config', GA_ID, {
    page_path,
    page_location: window.location.href,
    page_title: document.title || undefined,
  });
}

export function trackEvent(name, params = {}) {
  if (!GA_ID) return;
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', name, params);
}

